import { Button, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomAlert from "../../components/CustomAlert";
import CustomLoading from "../../components/CustomLoading";
import CustomModal from '../../components/CustomModal';
import CustomRadioButtonGroup from "../../components/CustomRadioButtonGroup";
import wsclients from "../../services/wsclients";

const useStyles = makeStyles((theme) => ({
    error: {
        color: theme.palette.common.red,
    },
}));

export default function ChangeBillingDay(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [options, setOptions] = useState([
        {
            label: '1',
            value: '1',
        },
        {
            label: '16',
            value: '16',
        },
        {
            label: '21',
            value: '21',
        },
        {
            label: '26',
            value: '26',
        },
    ]);
    const [selected, setSelected] = useState(null);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);
    const [showLoading, onShowLoading] = useState(false);

    const { subscriptionSelected } = props;
    let currentBillingDay = subscriptionSelected && subscriptionSelected.subscription && subscriptionSelected.subscription.terms && subscriptionSelected.subscription.terms.billing_day ? subscriptionSelected.subscription.terms.billing_day : null;
    console.log("props ChangeBillingDay: ", props);

    const onChangeOption = (item) => {
        console.log("item AAA:", item)
        setSelected(item);
    }

    const onProceed = async () => {
        console.log("subscriptionSelected: ", subscriptionSelected);
        if (selected) {
            setError(null);
            try {
                onShowLoading(true);
                let subId = subscriptionSelected && subscriptionSelected.subscription && subscriptionSelected.subscription.id ? subscriptionSelected.subscription.id : null;
                let result = await wsclients.subscriptions.updateSubscription(subId, {
                    action: 'CHANGE_BILLING_DAY',
                    billing_day: {
                        day_of_month: selected,
                    }
                });
                console.log("result updateSubscription: ", result);
                if (result.code == 'OK') {
                    onShowMessage({ show: true, content: t('CHANGE_BILLING_DAY_SUCCESS'), customClose: () => {
                        onShowMessage({});
                        props.onClose();
                        if(props.onRefresh) props.onRefresh();
                    } });
                } else {
                    onShowMessage({ show: true, content: t('CHANGE_BILLING_DAY_FAILED') });
                    return false;
                }
            } catch (ex) {
                console.log("exception updateSubscription: ", ex);
            }
            onShowLoading(false)
        } else {
            setError(t('please_choose_date'));
            return false;
        }
    }

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    return (
        <>
            <CustomModal
                open={props.open}
                handleClose={props.onClose}
            >
                <Grid item xs={12}>
                    <Grid item xs={12}>
                        {currentBillingDay && currentBillingDay.day_of_month && <Typography variant='body2' className={classes.text}>{t('current_billing_day')}: {mappingDay(currentBillingDay.day_of_month)} {t("of_the_month")}</Typography>}
                    </Grid>
                    <Grid item xs={12} marginTop={1}>
                        <Typography variant='body2' className={classes.text}>{t('new_billing_day')}</Typography>
                    </Grid>
                    <Grid item xs={12} marginTop={1}>
                        <CustomRadioButtonGroup
                            items={options}
                            selected={selected ? selected : null}
                            onChange={(event) => onChangeOption(event.target.value)}
                        />
                        {error && <Typography className={classes.error}>{error}</Typography>}
                    </Grid>
                    <Grid item xs={12} marginTop={1} justifyContent="center" style={{ textAlign: 'center' }}>
                        <Button variant='outlined' size='small' className={classes.button} style={{ marginRight: 8 }} onClick={() => props.onClose()}>{t('btn_cancel')}</Button>
                        <Button variant='contained' size='small' className={classes.button} onClick={() => onProceed()}>{t('btn_proceed')}</Button>
                    </Grid>
                </Grid>
            </CustomModal>

            {message && message.show && <CustomAlert
                open={message.show}
                message={message.content}
                onClose={message.customClose ? message.customClose : () => onShowMessage({})}
                showButtonClose={true}
            />}
            {showLoading && <CustomLoading open={showLoading} />}
        </>
    );
}

function mappingDay(day) {
    let billingDay = day;
    switch (day) {
        case 1:
            billingDay = billingDay + "st";
            break;
        case 2:
            billingDay = billingDay + "nd";
            break;
        case 3:
            billingDay = billingDay + "rd";
            break;
        default:
            billingDay = billingDay + 'th';
    }
    return billingDay;
}